export default "__VITE_ASSET__DB1$u5EU__"